import React, { useMemo } from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { LocalDate } from '@js-joda/core';
import Dropdown from '@/components/core/Dropdown';
import { Calendar } from 'react-date-range';
import { format } from 'date-fns';

const useStyles = makeStyles(theme => ({
  button: {
    width: '100%',
    justifyContent: 'center',
  },
}));

interface SingleDateFilterProps {
  value: LocalDate | null;
  onChange: (date: LocalDate) => void;
  maxDate?: Date;
  minDate?: Date;
}

const SingleDateFilter: React.FC<SingleDateFilterProps> = ({ value, onChange, maxDate, minDate }) => {
  const classes = useStyles();

  const jsDate = useMemo(() => {
    if (!value) return null;
    return new Date(value.toString() + 'T00:00:00.000');
  }, [value]);

  const displayDate = useMemo(() => {
    if (!jsDate) return 'Select Date';
    return format(jsDate, 'MMM DD, YYYY');
  }, [jsDate]);

  const handleChange = (selectedDate: Date) => {
    const localDate = LocalDate.of(selectedDate.getFullYear(), selectedDate.getMonth() + 1, selectedDate.getDate());
    onChange(localDate);
  };

  return (
    <Box>
      <Dropdown
        content={({ close }) => {
          const wrappedHandleChange = (date: Date) => {
            handleChange(date);
            close();
          };

          return () => <Calendar date={jsDate} maxDate={maxDate} minDate={minDate} onChange={wrappedHandleChange} />;
        }}
      >
        <Button variant="outlined" className={classes.button}>
          {displayDate}
        </Button>
      </Dropdown>
    </Box>
  );
};

export default SingleDateFilter;
